import { Outlet } from 'react-router-dom';

export function Page() {
  return (
    <>
      <header className="page--header">
        <div className="layout-container">
          <img
            src="https://www.ronderdigital.nl/themes/custom/ronder/logo.svg"
            alt="Logo Ronder"
            width="195"
            height="48"
          />
        </div>
      </header>
      <main id="main-content" className="page--main">
        <div className="layout-container">
          <Outlet />
        </div>
      </main>
    </>
  );
}
